export default {
  en: {
    messages: {
      required: fieldName => `${fieldName} is required.`,
      greater: (fieldName, value) => `${fieldName} must be greater than ${value}.`,
      email: () => 'Your email address is invalid. Please enter a valid address.',
    },
  },
};
